import { HostListener, OnDestroy, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LocalStorageDecorator } from 'src/app/libs/local-storage-decorator';
import {interval, of, Subscription, firstValueFrom} from "rxjs";
import {catchError, exhaustMap} from "rxjs/operators";
import {GoogleComponent} from "@pages/utils/google.component";
import {TratativaEnderecoService} from "@services/tratativa-endereco.service";
import {TratativasProdutoService} from "@services/tratativas-produto.service";
import {UploadFileService} from "@services/upload-file.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FazerPedidoService} from "@services/fazer-pedido.service";
import { HeaderComponent } from '../../components/header/header.component';
import { AlertResumoImportacaoComponent } from '../../components/alert-resumo-importacao/alert-resumo-importacao.component';
import { AlertSucessoComponent } from '../../components/alert-sucesso/alert-sucesso.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { AlertErroComponent } from '../../components/alert-erro/alert-erro.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { TratativasEnderecosComponent } from '../../components/tratativas-enderecos/tratativas-enderecos.component';
import { TratativasProdutosComponent } from '../../components/tratativas-produtos/tratativas-produtos.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { ImportadorDadosComponent } from '../importador-dados/importador-dados.component';

@Component({
    selector: 'app-tratativas',
    templateUrl: './tratativas.component.html',
    styleUrls: ['./tratativas.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, AlertResumoImportacaoComponent, AlertSucessoComponent, BotaoChatComponent, LoadingGenericoComponent, AlertErroComponent, BreadcrumbComponent, TratativasEnderecosComponent, TratativasProdutosComponent, FooterComponent, ImportadorDadosComponent]
})
export class TratativasComponent extends GoogleComponent implements OnInit , OnDestroy {

  constructor(
    readonly service: TratativaEnderecoService,
    readonly serviceProdu: TratativasProdutoService,
    readonly serviceResumoImportacao: UploadFileService,
    readonly activatedRoute: ActivatedRoute,
    readonly router: Router,
    readonly fazerPedidoService: FazerPedidoService,
    readonly uploadFileService: UploadFileService
  ) {
    super();
  }

  public qtdeInconsistenciasEnderecos: any = this.service.qtdeInconsistenciasEnderecos;
  public qtdeInconsistenciasProdutos: any = this.serviceProdu.qtdeInconsistenciasProdutos;
  public showAlertResumoImportacao: boolean = false;
  public showAlertSucesso: boolean = false;
  public tituloAlertSucesso: string = '';
  public substituloAlertSucesso: string = '';
  public dadosResumoImportacao: any = null;
  public idImportacao: any = localStorage.getItem('idImportacao');
  public idEmpresaLogada: any = localStorage.idEmpresaLogada;
  public alertLoading: boolean = false;
  public showAlertErro: boolean = false;
  public mensagemErroApi: string = '';
  public botao2: any = true;
  public recargaCerta = false;

  private readonly sectionApp = 'tratativas';
  private readonly screenName = 'tratativas';
  private readonly screenType = 'pagina';

  @LocalStorageDecorator()
  public showModal: 'AlertLoading'
    | ''
    | 'AlertErro';
  subscriptions: Array<Subscription> = [];

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(({recargaCerta}) => this.recargaCerta = recargaCerta);
    this.service.changeQtdeInconEnd.subscribe((response: any) => this.qtdeInconsistenciasEnderecos = response);
    this.serviceProdu.changeQtdeInconProdu.subscribe((response: any) => this.qtdeInconsistenciasProdutos = response);
    this.addTagManagerScreenView(null, null, null);
  }

  ngOnDestroy() {
    this.beforeunload();
  }

  @HostListener('window:beforeunload')
  beforeunload() {
    if (
      this.showModal === 'AlertLoading'
    ) {
      this.showModal = '';
    }
  }

  preConclusaoImportacao() {
    this.addTagManagerInteraction('box:button:click', 'ir-para-resumo', this.sectionApp, this.screenName, this.screenType);
    this.alertLoading = true;
    this.serviceResumoImportacao.preConclusaoImportacao(this.idImportacao, true)
    .subscribe({
      next: (response: any) => {
        setTimeout(() => {
          this.alertLoading = false;
          this.exibirResumoImportacao();
        }, 1000);
      },
      error: (erro: any) => {
        console.error(erro);
        this.showModal = 'AlertErro';
      }
    });
  }

  exibirResumoImportacao() {
    localStorage.avisoInconsistencia = false;
    this.serviceResumoImportacao.resumoImportacao(this.idImportacao)
    .subscribe({
      next: (response: any) => {
        this.dadosResumoImportacao = response;
        localStorage.setItem('idEmpresaPai', this.dadosResumoImportacao.summaryCompanys[0].companyId);
        this.showAlertResumoImportacao = true;
      },
      error: (erro: any) => {
        console.error(erro);
        this.dadosResumoImportacao = false;
      }
    });
  }

  async concluirImportacao() {
    try {
      await firstValueFrom(this.serviceResumoImportacao.concluirImportacao(this.idImportacao));
      this.checkStatusConclusao();
    } catch (error: any) {
      localStorage.removeItem('tratativas');
      console.error(error);
      this.alertLoading = false;
      this.showAlertErro = true;
      this.mensagemErroApi = 'Erro ao salvar os dados da importação.';
      this.serviceResumoImportacao.finalizaImportacao(this.idImportacao, 'cancelar').subscribe();
    }
  }

  async eventoAlertResumoImportacao(event: any) {
    if (event === 'cancelar') {
      this.serviceResumoImportacao.finalizaImportacao(this.idImportacao, 'cancelar').subscribe();
      this.showAlertResumoImportacao = false;
    } else if (event === 'sucesso') {
      this.alertLoading = false;
      this.showAlertResumoImportacao = false;
    } else if (event === 'concluir') {
      this.alertLoading = true;
      await this.concluirImportacao();
    }
  }

  private checkStatusConclusao() {
      this.showModal = 'AlertLoading';
      const subscription = interval(3000)
        .pipe(
          exhaustMap(() =>
            this.uploadFileService
              .getStatusConclusaoImportacao(this.idImportacao)
              .pipe(
                catchError((error) => {
                  console.error(error);
                  return of();
                })
              )
          )
        )
        .subscribe({
          next: (response: any) => {
            console.log(response);
            if (response.response.status === 'FINALIZADA') {
              subscription.unsubscribe();
              localStorage.removeItem('tratativas');
              this.alertLoading = false;
              this.tituloAlertSucesso = 'Importação realizada com sucesso!';
              this.substituloAlertSucesso = 'Clique em avançar se deseja fazer um pedido com importação de dados ou sair.';
              this.showAlertSucesso = true;
            } else if (response.response.status === 'ERRO') {
              subscription.unsubscribe();
              localStorage.removeItem('tratativas');
              this.alertLoading = false;
              this.showAlertErro = true;
              this.mensagemErroApi = 'Erro ao salvar os dados da importação.';
              this.serviceResumoImportacao.finalizaImportacao(this.idImportacao, 'cancelar').subscribe();
            }
          },
          error: (erro: any) => {
            console.error(erro);
            subscription.unsubscribe();
            localStorage.removeItem('tratativas');
            this.alertLoading = false;
            this.showAlertErro = true;
            this.mensagemErroApi = 'Erro ao salvar os dados da importação.';
            this.serviceResumoImportacao.finalizaImportacao(this.idImportacao, 'cancelar').subscribe();
          }
        });
      this.subscriptions.push(subscription);
  }

  eventoAlertErro(evento: any) { this.showAlertErro = false; }

  eventoAlertSucesso(evento: any) { this.showAlertSucesso = false; }

  async alertSucessoAvancou() {
    this.alertLoading = true
    this.alertLoading = false
    this.fazerPedidoService.getInicioCalculoValores(this.idEmpresaLogada, '', this.idImportacao, this.recargaCerta)
    .subscribe({
      next: (response: any) => {
        if (response.status === 'OK') {
          this.router.navigate(['/fazer-pedido-integral'], {
            queryParams: {
              recargaCerta: this.recargaCerta,
            },
          });
        }
      },
      error: (error: any) => {
        console.error(error);
      }
    });
  }

  cancelarImportacao() {
    this.addTagManagerInteraction('box:button:click', 'cancelar-importacao', this.sectionApp, this.screenName, this.screenType);
    this.alertLoading = true;
    this.serviceResumoImportacao.finalizaImportacao(this.idImportacao, 'cancelar')
    .subscribe({
      next: (response: any) => {
        this.alertLoading = false;
        localStorage.removeItem('tratativas');
        localStorage.removeItem(localStorage.getItem('idEmpresaLogada') + '.ImportadorDadosComponent.avisoInconsistencia.value');
        this.router.navigate(['importador-dados']);
      },
      error: (erro: any) => {
        console.error(erro);
        localStorage.removeItem('tratativas');
        localStorage.removeItem(localStorage.getItem('idEmpresaLogada') + '.ImportadorDadosComponent.avisoInconsistencia.value');
        this.router.navigate(['importador-dados']);
      }
    });
  }

}
